import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/ComparisonTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/HeroHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/Locations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/Parallax.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/Testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/VideoHero2.tsx");
